import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const TableManagerEmail = (props) => {
    const { rows } = props || {};

    return rows?.map((row) => (
        <TableRow
            key={row.name}
            sx={{
                "&:last-child td, &:last-child th": {
                    border: 0,
                },
            }}
        >
            <TableCell component="th" scope="row">
                {row.tracker_email}
            </TableCell>

            <TableCell align="right">{row.quantity}</TableCell>
        </TableRow>
    ));
};

export default TableManagerEmail;
